import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PathsUrls } from '../../utils/path_url';
import { Box, Button, IconButton, Drawer, List, ListItem, styled } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import rubaaiLogo from '../../assets/logo/rubaai_logo.svg';

// ===============================
// Styled Components
// ===============================
const NavButton = styled(Button)(() => ({
  color: '#F4F4F4',
  fontWeight: 600,
  fontSize: '20px',
  textTransform: 'none',
  position: 'relative',
  backgroundColor: 'transparent',
  padding: 0,
  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: '-6px',
    left: 0,
    width: '100%',
    height: '1px',
    backgroundColor: '#00BFFF', // underline color
    transform: 'scaleX(0)',
    transition: 'transform 0.3s ease',
  },
  '&:hover:after': {
    transform: 'scaleX(1)',
  },
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));

const menuItems = [
  { label: 'Home', route: PathsUrls.home_v2 },
  { label: 'About', route: PathsUrls.about },
  { label: 'Our Team', route: PathsUrls.ourTeam },
  { label: 'Careers', route: PathsUrls.careers || '/careers' },
  { label: 'Contact Us', route: PathsUrls.contactUs || '/contact-us' },
];

const ModernAppBar = () => {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <Box sx={{ width: '100%', backgroundColor: '#000000' }}>
      {/* Main Container */}
      <Box
        sx={{
          maxWidth: '1280px',
          margin: '0 auto',
          //padding: '12px 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* Logo */}
        <Box
          component="img"
          src={rubaaiLogo}
          alt="Rubaai Logo"
          sx={{
            height: { xs: '80px', md: '150px', lg: '160px' },
            width: 'auto',
            cursor: 'pointer',
            flexShrink: 0,
          }}
          onClick={() => navigate(PathsUrls.home_v2)}
        />

        {/* Desktop Navigation */}
        <Box
          component="ul"
          sx={{
            listStyle: 'none',
            display: { xs: 'none', md: 'flex' },
            alignItems: 'center',
            gap: '75px',
            margin: 0,
            padding: 0,
          }}
        >
          {menuItems.map((item) => (
            <li key={item.label}>
              <NavButton onClick={() => navigate(item.route)}>
                {item.label}
              </NavButton>
            </li>
          ))}
        </Box>

        {/* Mobile Menu Icon */}
        <IconButton
          sx={{ display: { xs: 'block', md: 'none' }, color: '#fff' }}
          onClick={() => setDrawerOpen(true)}
        >
          <MenuIcon fontSize="large" />
        </IconButton>

        {/* Mobile Drawer */}
        <Drawer
          anchor="right"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
        >
          <List sx={{ width: 250, backgroundColor: '#000', height: '100%' }}>
            {menuItems.map((item) => (
              <ListItem key={item.label}>
                <NavButton
                  onClick={() => {
                    navigate(item.route);
                    setDrawerOpen(false);
                  }}
                  sx={{ fontSize: '20px' }}
                >
                  {item.label}
                </NavButton>
              </ListItem>
            ))}
          </List>
        </Drawer>
      </Box>
    </Box>
  );
};

export default ModernAppBar;
